import React from "react";

import s from "./PageHeading.module.scss";

const PageHeading = ({ children, dataStyle }) => {
  return <div className={s.PageHeading} data-style={dataStyle}>{children}</div>;
};

export default PageHeading;
